import { render, staticRenderFns } from "./IconeLocalizacao.vue?vue&type=template&id=04ca293e"
import script from "./IconeLocalizacao.vue?vue&type=script&lang=js"
export * from "./IconeLocalizacao.vue?vue&type=script&lang=js"
import style0 from "./IconeLocalizacao.vue?vue&type=style&index=0&id=04ca293e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports